// Generated from GrouperFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete listener for a parse tree produced by GrouperFormula.
export default class GrouperFormulaListener extends antlr4.tree.ParseTreeListener {

	// Enter a parse tree produced by GrouperFormula#root.
	enterRoot(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#root.
	exitRoot(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#FieldReference.
	enterFieldReference(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#FieldReference.
	exitFieldReference(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#StringLiteral.
	enterStringLiteral(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#StringLiteral.
	exitStringLiteral(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#Brackets.
	enterBrackets(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#Brackets.
	exitBrackets(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#BooleanLiteral.
	enterBooleanLiteral(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#BooleanLiteral.
	exitBooleanLiteral(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#RightWhitespaceOrComments.
	enterRightWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#RightWhitespaceOrComments.
	exitRightWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#DecimalLiteral.
	enterDecimalLiteral(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#DecimalLiteral.
	exitDecimalLiteral(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#LeftWhitespaceOrComments.
	enterLeftWhitespaceOrComments(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#LeftWhitespaceOrComments.
	exitLeftWhitespaceOrComments(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#FunctionCall.
	enterFunctionCall(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#FunctionCall.
	exitFunctionCall(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#FieldByIdReference.
	enterFieldByIdReference(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#FieldByIdReference.
	exitFieldByIdReference(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#LookupFieldReference.
	enterLookupFieldReference(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#LookupFieldReference.
	exitLookupFieldReference(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#IntegerLiteral.
	enterIntegerLiteral(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#IntegerLiteral.
	exitIntegerLiteral(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#BinaryOp.
	enterBinaryOp(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#BinaryOp.
	exitBinaryOp(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#ws_or_comment.
	enterWs_or_comment(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#ws_or_comment.
	exitWs_or_comment(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#func_name.
	enterFunc_name(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#func_name.
	exitFunc_name(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#field_reference.
	enterField_reference(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#field_reference.
	exitField_reference(ctx) {
	}


	// Enter a parse tree produced by GrouperFormula#identifier.
	enterIdentifier(ctx) {
	}

	// Exit a parse tree produced by GrouperFormula#identifier.
	exitIdentifier(ctx) {
	}



}